import { toast } from 'react-toastify';
import FothToast from './FothToast';

const TOAST_METHODS = {
  success: 'success',
  error: 'error',
  warning: 'warn',
  info: 'info',
};

export const showToast = ({
  tone = 'info',
  title,
  description,
  action,
  toastId,
  autoClose,
}) => {
  const method = TOAST_METHODS[tone] || TOAST_METHODS.info;
  const hasAction = Boolean(action);

  return toast[method](({ closeToast }) => (
    <FothToast
      tone={tone}
      title={title}
      description={description}
      action={action}
      closeToast={closeToast}
    />
  ), {
    autoClose: autoClose ?? (hasAction ? 8000 : 5000),
    closeOnClick: false,
    className: 'foth-toast',
    icon: false,
    toastId,
  });
};
